export const IFRAME_MESSAGES = {
  RECEIVE_MODAL_READY: "public-modal-ready",
  RECEIVE_MODAL_CLOSE_TRIGGERED: "public-modal-close-triggered",
  SEND_FOCUS_ON_CLOSE_BUTTON: "focus-on-public-modal-close-button"
};

export const MODALS_NAMESPACE_KEY = "modals";
